window.SMTX.CustomerLogos = (function () {

 // return false;

  if ($('.customer-logos').length === 0) {
    return false;
  }

  // TODO infintie scroll
  // https://codepen.io/kassoss/pen/oxNvBq
  
  var initSlick = function () {
    $('.customer-logos-slick').slick({
      centerMode: false,
      accessibility: false, 
      centerPadding: '60px',
      slidesToShow: 5,
      slidesToScroll: 1,
      speed: 3500,
      arrows: false,
      autoplay: true,
      infinite: true,
      autoplaySpeed: 0,
      draggable: false,
      pauseOnFocus: false,
      pauseOnHover: false,
      cssEase: 'linear',
      responsive: [
        {
          breakpoint: 1280,
          settings: {
            //centerMode: true,
            //centerPadding: '40px',
            slidesToShow: 3
          }
        },
        {
          breakpoint: 768,
          settings: {
            //centerPadding: '40px',
            slidesToShow: 1,
          }
        }
      ]
    });
  }
  
  initSlick();
  
  var resizeTimer;
  $(window).resize(() => {
    // Debounce resize event
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      $('.customer-logos-slick').slick('unslick');
      initSlick();
    }, 250);
  });

  return {

  };

})();
